import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import {
  AsyncButton,
  Button,
  ButtonSize,
  ButtonStyle,
  colors,
  GiftItemStatus,
  IGiftItemResponse,
  theme,
  ZIndex,
} from '@one-tree/library'
import { RoutePath } from '../../../types/Routes'
import { useOrganisation } from '../../../context/OrganisationProvider'
import { ICategoryResponse } from '../../../types/API'
import { StateAction } from '../../../types/Aliases'
import PublishSwitch from '../../../components/PublishSwitch'
import { handleRestoreItem } from '../../../helpers/GiftItemHelper'

const Styles = styled.div`
  position: relative;
  background-color: ${colors.white};
  height: ${`${theme.giftItemControlPanelHeightPixels}px`};
  border: 1px solid ${colors.gray};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
  z-index: ${ZIndex.AboveContent + 1};
`

interface IGiftItemControlPanelProps {
  giftItem: IGiftItemResponse
  setGiftItem: StateAction<IGiftItemResponse>
  setItems?: StateAction<IGiftItemResponse[]>
  categories?: ICategoryResponse[]
}

function GiftItemControlPanel(props: IGiftItemControlPanelProps): ReactElement {
  const { giftItem, setGiftItem, setItems, categories } = props
  const history = useHistory()
  const { organisation } = useOrganisation()

  const isArchived = giftItem.status === GiftItemStatus.Archived

  const renderControls = isArchived ? (
    <AsyncButton
      buttonSize={ButtonSize.Mini}
      buttonStyle={ButtonStyle.Secondary}
      onClick={(): Promise<void> => handleRestoreItem(organisation, setItems, giftItem?.id)}
    >
      Restore
    </AsyncButton>
  ) : (
    <PublishSwitch item={giftItem} onSwitch={setGiftItem} categories={categories} />
  )

  return (
    <Styles>
      <Button
        buttonStyle={ButtonStyle.Primary}
        onClick={(): void => history.push(`${RoutePath.ItemGrid}/${giftItem.id}`)}
        buttonSize={ButtonSize.Mini}
      >
        Edit
      </Button>
      {renderControls}
    </Styles>
  )
}
export default GiftItemControlPanel
